import Vue from 'vue'
import { Dialog } from 'vant'
import { Language } from "@/language/index.js";

Vue.use(Dialog)
let dialog = Dialog
export const showDialog = params => {
  const { title, msg } = params
  dialog
    .alert({
      title: title,
      message: msg,
      confirmButtonText: Language.alert.confirmButtonText,
      className: 'showDialogClass'
    })
    .then(() => {
      dialog.close()
    })
}
export const hideDialog = () => {
  dialog.close()
}

export default {
  showDialog,
  hideDialog,
}
